export function specialCheckboxListener() {
    const specialCheckboxes = document.querySelectorAll('.specialcheckbox');

    specialCheckboxes.forEach(label => {
        const checkbox = label.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        label.addEventListener('click', event => {
            const target = event.target;

            if (target.tagName === 'A') return;

            if (target === checkbox) return;

            if (!label.hasAttribute('for')) {
                event.preventDefault();
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });

    document.querySelectorAll('.specialcheckbox a').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            e.stopImmediatePropagation();
            const href = link.getAttribute('href');
            const target = link.getAttribute('target') || '_self';
            window.open(href, target);
        });
    });

    document.querySelectorAll('.specialcheckbox input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                checkbox.closest('.specialcheckbox').classList.add('is-checked');
            } else {
                checkbox.closest('.specialcheckbox').classList.remove('is-checked');
            }
        });
    });
}
